import React from 'react';
import { render } from 'react-dom';
import AppRouter from './components/app-router/AppRouter';
import './index.css';
 

render(<AppRouter />, document.getElementById('app')
)


// WEBPACK FOOTER //
// ./src/index.js